import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'

import { useHistoryTrackerContext } from '../../providers/HistoryTrackerProvider'
import { getRegExpForOnboardingPathsThatFollow } from '../../utils/onboarding'

/**
 * Handles the back button for the onboarding process
 *
 * @returns An object containing the back title and onBack function.
 */
export function useOnboardingBackHandler() {
    const { findLastHistoryEntry } = useHistoryTrackerContext()

    const location = useLocation()

    const onboardingRegex = useMemo(() => {
        const obPath = location.pathname.split('/')[2]
        return getRegExpForOnboardingPathsThatFollow(obPath)
    }, [location])

    const lastEntry = findLastHistoryEntry({ excluding: onboardingRegex })

    return {
        title:
            lastEntry &&
            lastEntry.pathname !== '/onboarding' &&
            lastEntry.pathname !== '/onboarding/'
                ? 'Back'
                : undefined,
        onClick: lastEntry?.goBackTo,
    }
}
